import { apiFetch } from "@core/http";
import type { PortalRenewal, StaffSession } from "@core/session/types";

// SPEC-221: tres llamadas de la pantalla de acceso, todas contra
// contratos ya definidos en SPEC-003 (api/contracts/parts/00-base.yaml:202-318).
// No redeclara reglas de negocio: el backend decide bloqueo, no-revelación y
// vigencia del token.

export function signIn(
  username: string,
  password: string,
): Promise<StaffSession> {
  return apiFetch<StaffSession>("/v1/portal/access/sign-in", {
    method: "POST",
    body: { username, password },
  });
}

export function recoverPassword(
  email: string,
): Promise<{ validityHours: number }> {
  return apiFetch<{ validityHours: number }>("/v1/portal/access/recover", {
    method: "POST",
    body: { email },
  });
}

export function setPasswordWithToken(
  token: string,
  password: string,
  confirmation: string,
): Promise<void> {
  return apiFetch<void>("/v1/portal/access/password", {
    method: "PUT",
    body: { token, password, confirmation },
  });
}

// SPEC-003 §3.4: cambio obligatorio de contraseña dentro del shell ya
// autenticado (portalSession), sin token de recuperación.
export function changeMandatoryPassword(
  password: string,
  confirmation: string,
): Promise<void> {
  return apiFetch<void>("/v1/portal/access/must-change-password", {
    method: "PUT",
    body: { password, confirmation },
  });
}

export function renewSession(): Promise<PortalRenewal> {
  return apiFetch<PortalRenewal>("/v1/portal/access/renew", { method: "POST" });
}
